export const themeConfig = {
    isOpen: [], // for active default menu
    basename: '/',
    defaultPath: '/dashboard',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 4,
    opened: true,


};